import { render, staticRenderFns } from "./_taikai.vue?vue&type=template&id=ba5f79a4&"
import script from "./_taikai.vue?vue&type=script&lang=js&"
export * from "./_taikai.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports